export const spaces = {
    0: 0,
    4: "0.25rem",
    8: "0.5rem",
    10: "0.625rem",
    12: "0.75rem",
    16: "1rem",
    20: "1.25rem",
    24: "1.5rem",
    "half-56": "1.75rem",
    32: "2rem",
    40: "2.5rem",
    44: "2.75rem",
    48: "3rem",
    52: "3.25rem",
    56: "3.5rem",
    64: "4rem",
    72: "4.5rem",
    80: "5rem",
    88: "5.5rem",
    96: "6rem",
    104: "6.5rem",
    112: "7rem",
    120: "7.5rem",
    128: "8rem",
    256: "16rem"
};
// this could go into a layout prop as px : StandardXAxisPadding
// but it may be needed outside of that, its also quite application specific,
// more thought needed
export const StandardXAxisSpace = `calc((100vw * 0.08333) +  ${spaces[48]})`;
export const MegaXAxisSpace = `calc((100vw * 0.12) +  ${spaces[48]})`;
export const StandardXAxisPadding = [24, 24, 48, 48, 48, StandardXAxisSpace];
export const EditorialXAxisPadding = [
    24,
    24,
    48,
    56,
    StandardXAxisSpace,
    MegaXAxisSpace
];
//[24, 24, 48, 48, StandardXAxisPadding],
//[24, 24, 48, 48, topLevelXPageSpacing],
export const maxTopLevelXSpace = `calc((100vw * 0.08333)  ${spaces[48]})`;
//# sourceMappingURL=spaces.js.map